import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  AirportDropDown,
  AirportDropDownList,
  UiStateManagementService
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { Subscription } from 'rxjs';
import { AirportDropdownOverlayService } from './airport-dropdown-overlay.service';

@Component({
  selector: 'idp-airport-dropdown',
  standalone: true,
  template: '<ng-content></ng-content>',
  styleUrls: ['./airport-dropdown.component.scss']
})
export class AirportDropdownComponent implements OnInit, OnChanges, OnDestroy {
  @Input() openModal = false;
  @Input() airportModalContent!: AirportDropDown;
  @Input() selectedValue?: AirportDropDownList;
  @Output() searchValueEmit = new EventEmitter<string>();
  @Output() airportSelected = new EventEmitter<AirportDropDownList>();
  @Output() closeModal = new EventEmitter();
  @Input() searchErrorMessage = '';
  private elementRef = inject(ElementRef);
  private uiStateService = inject(UiStateManagementService);
  private overlayService = inject(AirportDropdownOverlayService);
  private subscription = new Subscription();

  ngOnInit(): void {
    this.subscription.add(
      this.uiStateService.toggleAirportDropDown$.subscribe(() => {
        if (this.overlayService.isOpen()) {
          this.overlayService.close();
        }
      })
    );

    this.subscription.add(
      this.overlayService.close$.subscribe(() => {
        this.closeModal.emit();
        document.getElementById('location-field')?.focus();
      })
    );
    this.subscription.add(
      this.overlayService.airportSelected$.subscribe((airport) => {
        this.airportSelected.emit(airport);
        document.getElementById('input-from-airport')?.focus();
      })
    );
    this.subscription.add(
      this.overlayService.searchValue$.subscribe((value) =>
        this.searchValueEmit.emit(value)
      )
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    const shouldOpen =
      changes['openModal']?.currentValue === true &&
      !this.overlayService.isOpen();
    if (shouldOpen) {
      this.overlayService.open(
        this.elementRef,
        this.airportModalContent,
        this.selectedValue
      );
    }

    const applyUpdates = () => {
      const newContent = changes['airportModalContent']?.currentValue;
      if (newContent !== undefined) {
        this.overlayService.updateContent(newContent);
      }

      const newSearchError = changes['searchErrorMessage']?.currentValue;
      if (newSearchError !== undefined) {
        this.overlayService.updateSearchError(newSearchError);
      }
    };

    applyUpdates();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.overlayService.close();
  }

  @HostListener('window:resize')
  onResize(): void {
    if (this.overlayService.isOpen() && !this.isMobileDevice()) {
      this.overlayService.updatePosition(this.elementRef);
    }
  }

  private isMobileDevice(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(
      navigator.userAgent
    );
  }
}
